// extracted by mini-css-extract-plugin
export var apiV2LimitsList = "api-v2-limits-list_YAvMQApCrnLcbJFa6y48";
export var apiV2LimitsListDisabled = "api-v2-limits-list_disabled_XLWRbb0A62CDl0XmM_v3";
export var apiV2LimitsListRemovableItem = "api-v2-limits-list__removable-item_MQI_gdliLT3U_yEPRBeh";
export var removableList = "removable-list_JJsWu1k2AntzAfl9HHik";
export var removableListCaption = "removable-list__caption_ZiaQfSH5DJ3OjluDEjlM";
export var removableListClose = "removable-list__close_yWnlo4i8sdtdahYhoidQ";